module.exports = "<div class=\"divider-group divider-group-box\"> <div class=row> <div class=col-xs-3> <div class=q-marg-vert-xxs> <span class=q-boldest>{%- orderedQty %}</span> {%- unitOfMeasure %} </div> </div> <div class=col-xs-3> <div class=\"q-marg-vert-xxs q-boldest\"> {%= bundleIcon %} {%= productId %} </div> </div> <div class=col-xs-4> <div class=\"q-marg-vert-xxs q-break-word\"> {%- productDescription %} </div> </div> <div class=col-xs-2> {%= productUnitsAvail %} </div> </div> </div> {%= optional.children %}";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/productOnReviewTab.html
// module id = 1367
// module chunks = 1